import React from 'react';
import { countriesData, getCountryByCode } from '../../lists/CountriesData';

const PhoneNumberInput = ({
    selectedCountry,
    phoneNumber,
    onCountryChange,
    onPhoneChange,
    error,
}) => {
    const handlePhoneInput = (e) => {
        const input = e.target.value;
        // Remove the dial code part before processing
        const numberWithoutDialCode = input.replace(selectedCountry.dialCode, '');
        const digitsOnly = numberWithoutDialCode.replace(/\D/g, '');

        if (digitsOnly.length <= selectedCountry.length) {
            onPhoneChange(digitsOnly);
        }
    };

    // Combine dial code with phone number for display
    const displayedValue = `${selectedCountry.dialCode}${phoneNumber}`;

    return (
        <div className={`phone-input-container ${error ? 'error' : ''}`} style={{ display: 'flex' }}>
            <select
                value={selectedCountry?.code}
                onChange={(e) => {
                    const country = getCountryByCode(e.target.value);
                    if (country) onCountryChange(country);
                }}
                style={{
                    borderRight: 'none',
                    flex: '2',
                    padding: '10px 0',
                    borderRadius: '6px 0 0 6px'
                }}
            >
                {countriesData.map((country) => (
                    <option key={country.code} value={country.code}>
                        {country.name} ({country.dialCode})
                    </option>
                ))}
            </select>

            <div style={{
                flex: '5',
                position: 'relative',
                // borderRadius: '0 6px 6px 0',
                // backgroundColor: '#fff'
            }}>
                <span style={{
                    position: 'absolute',
                    left: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    pointerEvents: 'none',
                    color: '#495057'
                }}>
                    {selectedCountry.dialCode}
                </span>
                <input
                    type="tel"
                    value={phoneNumber}
                    onChange={handlePhoneInput}
                    placeholder={selectedCountry?.placeholder}
                    maxLength={selectedCountry?.length}
                    style={{ borderRadius: '0 6px 6px 0', paddingLeft: selectedCountry?.padding || '50px' }}
                />
            </div>
        </div>
    );
};

export default PhoneNumberInput;